var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from 'react';
import { AdminLayout } from 'src/Layouts';
import { useHistory } from 'react-router-dom';
import Modal from 'src/Components/Common/DeleteModal';
import { ticketsService } from 'src/Utils/ticketsService';
import { TableContainer, TopBar, Filters, FilterWrapper, } from './styles';
import Button from 'src/Components/Common/AdminButton/Button';
import ServerPaginatedTable from 'src/Components/Common/ServerPaginatedTable';
import SearchInput from 'src/Components/SearchInput';
import { useDebounce } from 'src/Utils/hooks/useDebounce';
import FilterDropdown from 'src/Components/FilterDropdown';
import { getSearchParams } from 'src/Utils/getQueryParams';
import { ROUTES, TICKET_REMINDERS_API } from 'src/Utils';
import { useSearchParams } from 'src/Utils/hooks/useSearchParams';
import { useBuildingOptions } from 'src/Utils/hooks/useBuildingOptions';
import { useTicketRemindersCols } from './hooks/useTicketRemindersCols';
import AdminSection from 'src/Components/AdminSection/AdminSection';
function TicketReminders() {
    var _this = this;
    var _a;
    var history = useHistory();
    var searchParams = useSearchParams();
    var _b = useState((_a = searchParams.get('ticket_number')) !== null && _a !== void 0 ? _a : ''), ticketNumber = _b[0], setTicketNumber = _b[1];
    var _c = useState(null), notified = _c[0], setNotified = _c[1];
    var _d = useState(null), buildingId = _d[0], setBuildingId = _d[1];
    var debouncedTicketNumber = useDebounce(ticketNumber, 500);
    useEffect(function () {
        var _a;
        var ticketNumberFromUrl = (_a = searchParams.get('ticket_number')) !== null && _a !== void 0 ? _a : '';
        setTicketNumber(ticketNumberFromUrl);
    }, [searchParams]);
    var _e = useTicketRemindersCols(), columns = _e.columns, handleDelete = _e.handleDelete, isDeleteModalOpen = _e.isDeleteModalOpen, rowActions = _e.rowActions, setIsDeleteModalOpen = _e.setIsDeleteModalOpen;
    var handleCreate = function () {
        var searchParams = getSearchParams({ ticket_number: ticketNumber || undefined });
        history.push(ROUTES.crear_recordatorio_de_ticket +
            (searchParams ? "?" + searchParams : ''));
    };
    var fetchTicketReminders = function (paginationParams) { return __awaiter(_this, void 0, void 0, function () {
        var params, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = __assign({}, paginationParams);
                    if (debouncedTicketNumber.length > 0) {
                        params.ticket_number = Number(debouncedTicketNumber);
                    }
                    if (notified !== null) {
                        params.notified = notified;
                    }
                    if (buildingId !== null) {
                        params.building_id = buildingId;
                    }
                    return [4 /*yield*/, ticketsService.getTicketReminders(params)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, {
                            data: response.ticket_reminders,
                            totalPages: response.total_pages,
                        }];
            }
        });
    }); };
    var buildingOptions = useBuildingOptions().buildingOptions;
    return (React.createElement(AdminLayout, null,
        React.createElement(AdminSection, { title: "Recordatorios de tickets" },
            React.createElement(TableContainer, null,
                React.createElement(TopBar, null,
                    React.createElement(Filters, null,
                        React.createElement(SearchInput, { label: "# Ticket", placeholder: "Buscar # de ticket", value: ticketNumber, onChange: function (value) {
                                if (Number(value) || value === '') {
                                    setTicketNumber(value);
                                }
                            } }),
                        React.createElement(FilterWrapper, null,
                            React.createElement(FilterDropdown, { width: 250, label: "Edificio", clearable: true, placeholder: "Todos", value: buildingId, options: buildingOptions, onChange: function (value) { return setBuildingId(value); } })),
                        React.createElement(FilterDropdown, { width: 160, label: "Estado", clearable: true, placeholder: "Todos", value: notified, options: [
                                { label: 'Entregado', value: 'true' },
                                { label: 'Pendiente', value: 'false' },
                            ], onChange: function (value) {
                                return setNotified(value);
                            } })),
                    React.createElement(Button, { onClick: handleCreate }, "Crear recordatorio")),
                React.createElement(ServerPaginatedTable, { fetchData: fetchTicketReminders, queryKey: [
                        TICKET_REMINDERS_API,
                        debouncedTicketNumber,
                        notified,
                        buildingId,
                    ], columns: columns, getRowKey: function (row) { return row.id; }, rowActions: rowActions }))),
        React.createElement(Modal, { isOpen: isDeleteModalOpen, setIsOpen: setIsDeleteModalOpen, itemLabel: "el recordatorio", onDelete: handleDelete })));
}
export default TicketReminders;
